<template>
	<svg viewBox="0 0 24 24" aria-hidden="true">
		<path d="M7 4h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" />
		<path d="M9 7h6" />
		<path d="M10 18h4" />
	</svg>
</template>
